import { usePageSEO } from '@/hooks/usePageSEO';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Prix from './components/Prix';
import Materiaux from './components/Materiaux';
import Process from './components/Process';
import Garantie from './components/Garantie';
import Checklist from './components/Checklist';
import Temoignage from './components/Temoignage';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import CTAFinal from './components/CTAFinal';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://couvreur-levis.com/' },
    { '@type': 'ListItem', position: 2, name: 'Réfection toiture', item: 'https://couvreur-levis.com/refection-toiture-levis' },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Réfection de toiture',
  provider: { '@type': 'LocalBusiness', '@id': 'https://couvreur-levis.com/#business' },
  areaServed: { '@type': 'City', name: 'Lévis' },
  description: "Réfection complète de toiture résidentielle à Lévis. Bardeau, tôle, membrane élastomère. Couvreurs partenaires RBQ certifiés, garantie 10 ans.",
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'CAD',
    lowPrice: '7000',
    highPrice: '22000',
    offerCount: '4',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Combien de temps prend une réfection complète ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Ça dépend de la superficie et de la complexité. Un bungalow standard : 1 à 2 jours. Une maison de 2 étages avec plusieurs pignons : 3 à 4 jours. La tôle métal prend un peu plus de temps car chaque panneau est coupé sur mesure. On vous donne un échéancier précis dans la soumission.",
      },
    },
    {
      '@type': 'Question',
      name: 'Faut-il quitter la maison pendant les travaux ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Non, pas nécessairement. Le bruit est présent pendant la journée, mais vous pouvez rester chez vous. On protège vos accès, vos plantes et vos objets fragiles. Seule exception : si on doit remplacer le pontage dans certaines zones, on peut vous demander de vider un grenier temporairement.",
      },
    },
    {
      '@type': 'Question',
      name: 'Mon assurance couvre-t-elle la réfection ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "L'usure normale n'est pas couverte. Par contre, si votre toiture a été endommagée par une tempête, du grêlon ou des vents forts, votre assurance peut couvrir tout ou partie des travaux. On vous aide à préparer le dossier avec un rapport photo détaillé et une attestation de notre inspecteur.",
      },
    },
    {
      '@type': 'Question',
      name: "Que faire si le pontage est endommagé sous l'ancienne toiture ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "C'est exactement pourquoi on enlève l'ancienne toiture au complet avant la nouvelle. On inspecte le pontage planche par planche. Les sections pourries sont remplacées avant l'installation de la membrane d'étanchéité. C'est inclus dans notre soumission, pas de surprise.",
      },
    },
    {
      '@type': 'Question',
      name: 'Travaillez-vous en automne et début hiver ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "On planifie les réfections complètes de mai à octobre pour les bardeaux, car ils ont besoin de températures au-dessus de 10°C pour sceller correctement. La tôle métal peut parfois être installée plus tard dans l'automne. On fait des réparations d'urgence toute l'année, oui.",
      },
    },
  ],
};

export default function RefectionPage() {
  usePageSEO({
    title: 'Réfection de toiture Lévis | Prix 2026 | Garantie 10 ans',
    description: 'Réfection complète de toiture à Lévis. Bardeau, tôle, membrane. Prix dès 7000$. Garantie 10 ans. Soumission gratuite en 2h. 418-476-9950.',
    urlPath: '/refection-toiture-levis',
    keywords: 'réfection toiture Lévis, remplacement toiture, bardeau neuf, toiture neuve, couvreur',
    ogImage: '/og/og-refection-toiture-levis.jpg',
    ogImageAlt: 'Réfection de toiture à Lévis - Garantie 10 ans',
    jsonLdSchema: [breadcrumbSchema, serviceSchema, faqSchema],
  });

  return (
    <div className="font-inter min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Prix />
        <Materiaux />
        <Process />
        <Garantie />
        <Checklist />
        <Temoignage />
        <FAQ />
        <QuoteForm />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}